import anime from 'animejs';

const text = (el) => {
  const basicTimeline = anime.timeline();

  basicTimeline.add({
    targets: el.node,
    duration: 0,
    opacity: 1,
    offset: 0,
  })
  .add({
    targets: el.instance[0].lines,
    duration: 900,
    delay: (el) => {
      const i = getComputedStyle(el).getPropertyValue('--line-index');
      return i * 80;
    },
    opacity: [0, 1],
    translateY: ['100%', '0%'],
    easing: [0.25, 0.87, 0.43, 1],
    offset: 0,
  });

  basicTimeline.finished.then(() => {
    el.node.removeAttribute('js-anim');
    el.node.innerHTML = el.innerHtml;
  });

  return basicTimeline;
};

export default text;
